var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBasemap32(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    heigth: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 30h13V17H2zm1-12h11v4.684l-1.33.112s-.964.19-1.316.302c-.501.159-.765-.247-1.528-.99a2.738 2.738 0 0 0-2.224-1.066 2.538 2.538 0 0 0-2.39 1.045c-.306.453.01 1.248-.5 2.038a2.44 2.44 0 0 1-1.529.161L3 24.251zm0 7.374l.31.047A4.479 4.479 0 0 0 5.311 25a2.44 2.44 0 0 0 .6-1.413c.126-1.22.361-1.595 1.65-1.586a1.976 1.976 0 0 1 1.8 1.003c1.01.879 1.553 1.282 2.293 1.048a3.093 3.093 0 0 1 .34-.08l2.005-.2V29H3zM2 15h13V2H2zm1-1v-3.568A8.172 8.172 0 0 1 6.879 14zM14 3v6.704C9.904 8.754 8.218 4.912 7.629 3zM3 3h3.585c.567 1.993 2.43 6.71 7.415 7.728V14H7.962C6.754 10.804 3.2 9.418 3 9.343zm14-1v13h13V2zm6 3V3h3v3h-3zm1 2v2h-4V6h2v1zm5 7H18V3h4v2h-3v5h3v3h7zm0-2h-6v-2h2V9h4zm0-4h-4V7h2V3h2zM17 30h13V17H17zm12.01-1H26v-7h3.01zM17.99 18h11.02v3H17.99zm0 4H25v3h-3v1h3v3h-7.01z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h32v32H0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasemap32);
export default __webpack_public_path__ + "static/media/basemap-32.ac4aab7309fbb73a6c192f43af49f1c2.svg";
export { ForwardRef as ReactComponent };